import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { chatKeys } from "./keys";
import { Message } from "../../components/alfie-chat";

interface Consultation {
  cost: number;
  name: string;
}

interface Medication {
  cost: number;
  name: string;
}

interface MedicalPlan {
  medical_plan: {
    consultation: Consultation;
    medication: Medication;
    payment_status: string;
    plan_id: string;
    program: string;
    session_id: string | null;
    user_id: string;
    supplementary_questionnaire: any;
  }
}

// TODO: Define the actual type for chat history response
interface GetChatHistoryResponse {
    chat_history: {
        alfie_chat_histor: Array<{
            created_at: string;
            message: Message[];
            session_id: string;
            user_id: string;
            _id: string;
          }>;
        onboard_chat_history: Array<{
            created_at: string;
            message: Message[];
            session_id: string;
            user_id: string;
            _id: string;
          }>;
    }
}

export const chatHistoryQueryOptions = (sessionId: string) => {
  return queryOptions({
    queryKey: chatKeys.chatHistory(sessionId),
    retry: false,
    queryFn: async () => {
      try {
        const response = await apiClient(`/sessions/${sessionId}/chat-history`);
        const result = await handleResponse<GetChatHistoryResponse>(response);

        if (!result.success) {
          throw new Error(result.error);
        }
        // Return the last item in the chat history array
        // console.log("chat-history-current", result.data.chat_history.onboard_chat_history)
        return result.data.chat_history.onboard_chat_history;
      } catch (error) {
        handleApiError(error);
        throw error;
      }
    },
    enabled: !!sessionId,
  });
};

export const medicalPlanQueryOptions = (planId?: string | null) => {
  return queryOptions({
    queryKey: ["medical-plan", planId],
    retry: false,
    queryFn: async () => {
      try {
        const response = await apiClient(`/users/medical-plan`);
        const result = await handleResponse<MedicalPlan>(response);

        if (!result.success) {
          throw new Error(result.error);
        }

        return result.data;
      } catch (error) {
        handleApiError(error);
        throw error;
      }
    },
    enabled: !!planId,
  });
};


